/*
 * @Author: paige.zhang 
 * @Date: 2019-03-25 16:04:20 
 * @Last Modified by: paige.zhang
 * @Last Modified time: 2019-05-13 15:46:37
 */
<template>
  <el-breadcrumb separator=" " class="wis-breadcrumb" ref="breadcrumb" style="line-height: 30px;">
    <el-breadcrumb-item>{{breadcrumbTitleName}}</el-breadcrumb-item>
    <slot name="back-btn"></slot>
    <span class="fr">
      <span
        v-for="(item, index) in breadcrumbUrlArr.filter(i=>i.url!=='/user/login')"
        :key="index"
        @click="goRouter(item)"
        class="cur_pointer"
      >&nbsp;{{breadcrumbUrlWordMap[item.url]}}<span>&nbsp;&gt;</span></span>
      
      <span class="main-col">{{breadcrumbLastName}}</span>
    </span>
  </el-breadcrumb>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { setTimeout } from 'timers';
import { debug, debuglog } from 'util';
export default {
  props: {
    // 左侧文字
    breadcrumbTitleName: {
      type: String,
      default: ""
    },
    // 面包屑最后一个字
    breadcrumbLastName: {
      type: String,
      default: ""
    },
    // 面包屑当前页面
    breadcrumbCurrentUrl:{
      type: String,
      default: ""
    }

  },
  data() {
    return {
    
    };
  },

  mounted() {
  },
  methods: {
    // 路由跳转
    goRouter(item) {
      if(this.breadcrumbCurrentUrl == '/certificate/certificateLevel' && item.url!='/study/schedule') {
        localStorage.removeItem('scheduleTab')
      } 
      setTimeout(()=>{
        this.$router.push({ path: item.url, query: item.query });
      }, 0)
    },
    // 存放面包屑url query方法
    ...mapMutations("common", ["SETBREADCRUMBURLARR"])
  },
  computed: {
    // breadcrumbUrlWordMap 维护的url-word数组
    ...mapGetters("common", ["breadcrumbUrlArr"])
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/stuBreadcrumb.vue